module.exports = __webpack_public_path__ + "img/Equipa_PS_1.c7d5369a.png";